import { 
    IPlotData as ICorePlotData, 
    createPlotData as createCorePlotData, 
    ISourceData as ICoreSourceData, 
    createData as createCoreData, 
    addDataFactory
} from "../../core";
import { IDashboardSharedViewModel, indigenousGroups, KeyedDimension } from "./viewModel";

export { indigenousGroups }

/**
 * Sort asc
 * @param a 
 * @param b 
 */
export const sort = (_: ISourceData, a: string, b: string): number => {
    return ((a > b) ? -1 : ((a < b) ? 1 : 0));
};

/**
 * Plot data source
 */
export type IPlotData = ICorePlotData;

/**
 * Raw data source. Used to shape and accumulate.
 */
export type ISourceData = ICoreSourceData;

/**
 * Create a new plot data object.
 */
export const createPlotData = createCorePlotData;

/**
 * Create a new source data object
 */
export const createData = createCoreData;

function isIndigenous(indigenousStatusId: number): boolean {
    return indigenousStatusId && [1, 2, 3, 5].indexOf(indigenousStatusId) !== -1;
}

/**
 * Convert raw id to enum
 * @param id
 */
export const toIndigenousGroup = (id: number): KeyedDimension => {
    if (!id || id === 9)
        return indigenousGroups.unknown;

    if (isIndigenous(id)) 
        return indigenousGroups.indigenous;

    return indigenousGroups.nonIndigenous;
};

/**
 * Accumulate the vm value into the source data object.
 * 
 * @param vm source view model
 * @param into data object to accumulate into
 */
export const addData = addDataFactory((vm: IDashboardSharedViewModel) => vm.indigenousGroup.name);
